<template>
    <div class="media">
        <template  v-for="(item) in medias" >
            <a class="media-list"  href="javascript:;" :key="item.id" v-if="item.display" @click="redirectUrl(item)">
                <img class="media-list-icon icon-default" :src="require('@/assets/images/icon/'+(item.iconName).toLowerCase()+'.png')" alt="" ondragstart="return false;">
                <img class="media-list-icon icon-active" :src="require('@/assets/images/icon/'+(item.iconName).toLowerCase()+'-active.png')" alt="" ondragstart="return false;">
                <img v-if="item.type == 2" :src="item.content" class="media-list-code" alt="" ondragstart="return false;">
                <div class="media-list-txt"><span>{{item.desc}}</span></div>
            </a>
        </template>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { qiyuInit } from '@/utils/qiyu'

export default {
    name: 'media',
    props: {
        // type分类 home qq weixin blibli tieba wenjuan
        medias: {
            type: Array,
            required: true,
        },
        wdId: {
            validator (value) {
                const type = typeof value;
                return ['string', 'number'].includes(type);
            },
            required: true,
        },
        account: {
            required: true,
            type: String,
        },
    },
    computed: {
    },
    methods: {
        redirectUrl (item) {
            const { content, type, iconName } = item;
            const {
                wdId, account
            } = this;

            console.log(wdId, 'wdId')
            console.log(account, 'account')
            const hasQuery = content.includes('?');
            const joinPart = hasQuery ? '&' : '?';
            if (content && type == 1) {
                const uidPart = `${wdId !== '' ? joinPart + 'u=' + wdId : ''}`;
                const accountPart = `${account !== '' ? '&t=' + encodeURIComponent(account) : ''}`;
                const constPart = '&qtype=4493270&templateId=';
                const url = `${iconName === 'service'
                    ? content + uidPart + accountPart + constPart
                    : content}`;
                const open = () => window.open(url);
                if (iconName !== 'service') {
                    return open();
                }
                const data = [
                    {
                        key: 'game',
                        label: '游戏',
                        value: '云·生死狙击2',
                        index: 0,
                    },
                    {
                        key: 'sub_channel_id',
                        label: '渠道id',
                        value: '1',
                        index: 1,
                    },
                    {
                        key: 'channel_id',
                        label: '子渠道id',
                        value: '4261',
                        index: 2,
                    },
                ];
                if (wdId) {
                    data.push({
                        key: 'wd_id',
                        label: '无端id',
                        value: wdId,
                        index: 3,
                    });
                }
                const config = {
                    data: JSON.stringify(data),
                };
                if (wdId) {
                    config.uid = wdId;
                }
                if (account) {
                    config.name = account;
                }
                qiyuInit(config).then(open);
            }
        },
    },
};
</script>
<style scoped>
.media{
    position: absolute;
    left: 50px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 8;
}
.media .media-list{
    display: block;
    width: 36px;
    height: 30px;
    margin-bottom: 30px;
    position: relative;
}
.media .media-list img{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.media .media-list .icon-active{
    display: none;
}
.media .media-list:hover .icon-active{
    display: block;
}
.media .media-list:hover .icon-default{
    display: none;
}
.media .media-list:hover .media-list-code{
    opacity: 1;
    transform: scale(1);
    transition: .2s ease;
}
.media .media-list:hover .media-list-txt{
    display: flex;
}
.media .media-list .media-list-code{
    position: absolute;
    top: -40px;
    left: 70px;
    opacity: 0;
    transform: scale(0);
    transition: .2s ease;
    width: 100px;
    height: 100px;
}
.media-list .media-list-txt{
    /*width: 60px;*/
    /*height: 21px;*/
    padding: 5px;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 30px;
    left: 0px;
    z-index: 2;
    background: rgba(0,0,0,0.8);
    overflow: hidden;
    display: none;
}
.media-list .media-list-txt span{
    color: #fff;
    font-size: 12px;
    white-space: nowrap;
    display: inline-block;
}
@media screen and (max-width:1100px) {
    .media-list .media-list-txt span{
        transform: scale(0.8);
    }
}
</style>
